import {UserApiService} from "./service";
import {User} from "../../context/users";
import { mockUser } from "../../utils/mockData";

export class MockUserApiService implements UserApiService {
    async fetchUserMetadata(email: string): Promise<User> {
        // Simulate a 1-second delay
        await new Promise(resolve => setTimeout(resolve, 1000));
        return mockUser;
    }
}
